import { AutoMap } from "@automapper/classes"
import { ESubContractingLab } from "./enums/sub-contracting-lab"

export class PlanningConfiguration {
    @AutoMap()
    SubContractingLab!: ESubContractingLab
    @AutoMap()
    AdresseDepart!: string
    @AutoMap()
    LongitudeDepart!: number
    @AutoMap()
    LatitudeDepart!: number
    @AutoMap()
    AdresseArrivee!: string
    @AutoMap()
    LongitudeArrivee!: number
    @AutoMap()
    LatitudeArrivee!: number
    @AutoMap()
    HeureDebutJournee!: string
    @AutoMap()
    AmplitudeHoraireMaximale!: number
    @AutoMap()
    HeurePauseMinimale!: string
    @AutoMap()
    DureePause!: number
    @AutoMap()
    CouleurTrajetGoogleMaps!: string
}
